import { styled, Box as MuiBox, Stack as MuiStack } from "@mui/material";

export const Box = styled(MuiBox)(
  ({ theme }) => `
  &.certificate-display-wrapper {
    display: flex;
    justify-content: flex-end;
    width: 126px;
    .label {
      white-space: nowrap;
    }
  }

  &.certificate-text {
    font-size: 11px;
    display: flex;
    gap: 5px;
    align-items: center;
    cursor: pointer;
    svg path {
      fill: ${theme.palette.grey[700]};
    }
    &.red {
      color: ${theme.palette.alert};
      svg path {
        fill: ${theme.palette.alert};
      }
    }
    &.grey {
      color: ${theme.palette.grey[400]};
      svg path {
        fill: ${theme.palette.grey[400]};
      }
    }
  }

  &.certificate-button {
    display: flex;
    gap: 2px;
    align-items: center;
    font-size: 11px;
    font-weight: 500;
    border: solid 1px ${theme.palette.unoblue};
    border-radius: 2px;
    color: ${theme.palette.unoblue};
    padding: 0 4px;
    cursor: pointer;
    height: 28px;

    svg {
      width: 8px;
      height: 8px;
    }

    .doctor-name {
      max-width: 38px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  &.contents {
    width: 300px;
    min-height: 100px;
    font-size: 13px;
  }
`
);

export const Stack = styled(MuiStack)``;
